import React from 'react';

import DogTraining from '@rover/icons/svg/dog-training.svg';
import type { Image } from '@rover/rsdk/src/apiClient/latest/model/image';
import { MethodologyEnum } from '@rover/rsdk/src/apiClient/latest/model/methodologyEnum';
import { TrainerProfileDetailsMethodology } from '@rover/rsdk/src/apiClient/latest/model/trainerProfileDetailsMethodology';

import InfoBox from '../InfoBox';

import MethodologyDetailsModal from './MethodologyDetailsModal';

const ICON_SIZE = 24;

type MethodologySectionProps = {
  methodology?: TrainerProfileDetailsMethodology;
  methodologyCustom?: string;
  methodologyDetails?: string;
  name: string;
  defaultImage: Image;
  isTrainerProfileReordering?: boolean;
};

// TODO (DEV-104195): Translate below text after training pilot launch
const DISPLAY_TEXT_FOR_METHODOLOGY = {
  [MethodologyEnum.balanced]: 'Balanced',
  [MethodologyEnum.dominance]: 'Dominance',
  [MethodologyEnum['positive-reinforcement']]: 'Positive Reinforcement',
};

export const getMethodologyString = (
  methodology?: TrainerProfileDetailsMethodology,
  methodologyCustom?: string
): string => {
  if (methodology) {
    return DISPLAY_TEXT_FOR_METHODOLOGY[methodology];
  }
  if (methodologyCustom) {
    return methodologyCustom;
  }
  // TODO (DEV-104195): Translate below text after training pilot launch
  return 'Unavailable';
};

const MethodologySection: React.FC<MethodologySectionProps> = ({
  methodology,
  methodologyCustom,
  methodologyDetails,
  name,
  defaultImage,
  isTrainerProfileReordering = false,
}) => {
  const methodologyString = getMethodologyString(methodology, methodologyCustom);

  return (
    <InfoBox isTrainerProfileReordering={isTrainerProfileReordering}>
      <InfoBox.Icon>
        <DogTraining width={ICON_SIZE} height={ICON_SIZE} />
      </InfoBox.Icon>
      <InfoBox.BoldText isTrainerProfileReordering={isTrainerProfileReordering}>
        {methodologyString}
      </InfoBox.BoldText>
      {methodologyDetails && (
        <>
          <InfoBox.Text textColor={isTrainerProfileReordering ? 'secondary' : 'primary'}>
            {methodologyDetails}
          </InfoBox.Text>
          <InfoBox.Link>Read full methodology</InfoBox.Link>

          <InfoBox.Modal>
            <MethodologyDetailsModal
              methodology={methodologyString}
              methodologyDetails={methodologyDetails}
              shortName={name}
              defaultImage={defaultImage}
            />
          </InfoBox.Modal>
        </>
      )}
    </InfoBox>
  );
};

export default MethodologySection;
